import { Link } from "react-router-dom"

const PortifolioTitleComponent = () => {
    return (
        <div className="about-title">
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="title-text text-center">
                        <h2>Clientes</h2>
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            <li>
                                Clientes
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PortifolioTitleComponent
